import { render } from "./RoutePersons.vue?vue&type=template&id=18f2ab28&scoped=true&ts=true"
import script from "./RoutePersons.vue?vue&type=script&lang=ts"
export * from "./RoutePersons.vue?vue&type=script&lang=ts"

import "./RoutePersons.vue?vue&type=style&index=0&id=18f2ab28&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18f2ab28"]])

export default __exports__